import React, { useState } from 'react';
import Modal from 'react-modal';
import { connect } from 'react-redux';

import FormSelect from '../forms/FormSelect';
import FormInput from '../forms/FormInput';
import api from '../../api/api';
import uri from '../../variables/uri';

const customStyles = {
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)',
        background: '#f9f9f9',
        padding: '24px'
    },
    overlay: {
        background: "#00000080"
    }
};

const NewReleaseModal = ({ isOpen, bookName, bookArr, onClose, bookList, onSuccess }) => {
    const [book, setBook] = useState(bookName);
    const [isLoading, setIsLoading] = useState(false);
    const [version, setVersion] = useState('');
    const [errorMessage, setErrorMessage] = useState('');

    const onBookChange = (value) => {
        setBook(value);
    }
    const onVersionChange = (value) => {
        setVersion(value);
    }
    const onSubmit = async () => {
        setIsLoading(true);
        const org = bookList.find(item => book === `${item.BookName} ver.${item.BookReleaseVersion}`);
        try {
            const response = await api.get(`${uri.GET_CLONE_BOOK}?bookCode=${org.BookCode}&versionCode=${version}&lastBookReleaseId=${org.BookReleaseId}`);
            if(response.status === 200) {
                onClose();
                onSuccess();
            };
        } catch (ex) {
            setErrorMessage('Version code already existed for this book.')
            setIsLoading(false);
        }
    }

    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={!isLoading ? onClose : () => { }}
            style={customStyles}
            contentLabel="Message">
            <div>
                <div style={{ minWidth: '300px' }} className="flex-h flex-between">
                    <div>
                        <h1 className="f-200">New Release</h1>
                        <h4 className="f-300">Create a new release version</h4>
                    </div>
                </div>
                <div className="mt-16 mb-16" style={{ border: '1px solid #ddd', borderRadius: '20px' }}></div>
                <FormSelect
                    name="DOA Book"
                    value={book}
                    options={bookArr}
                    onValueChange={onBookChange}
                    disabled={isLoading} />
                <FormInput
                    name="Version Code"
                    value={version}
                    onValueChange={onVersionChange}
                    readonly={isLoading} />
                <h3 className="has-text-danger mt-24 has-text-centered">{errorMessage}</h3>
                <button disabled={version === '' || !book} onClick={() => onSubmit()} className={`mt-24 button is-success is-fullwidth center ${isLoading && 'is-loading'}`}>Confirm</button>
            </div>
        </Modal>
    );
}

const mapStateToProps = (state) => {
    return {
        bookList: state.doa.queryBookList
    }
}

export default connect(mapStateToProps)(NewReleaseModal);